import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { getDoc, doc } from 'firebase/firestore';
import { db } from '../firebase';
import { enrichVersesByIds } from '../utils/verseEnrich';

export default function EnrichNewVerses() {
  const location = useLocation();
  const navigate = useNavigate();
  const newVerseIds = location.state?.newVerseIds || [];
  const [verses, setVerses] = useState([]);
  const [enriching, setEnriching] = useState(false);
  const [enrichStatus, setEnrichStatus] = useState('');

  useEffect(() => {
    async function fetchVerses() {
      const loaded = [];
      for (const id of newVerseIds) {
        const snap = await getDoc(doc(db, 'verses', id));
        if (snap.exists()) loaded.push({ id, ...snap.data() });
      }
      setVerses(loaded);
    }
    if (newVerseIds.length) fetchVerses();
  }, [newVerseIds]);

  const handleEnrichAll = async () => {
    setEnriching(true);
    setEnrichStatus('');
    await enrichVersesByIds(newVerseIds, (status) => setEnrichStatus(status.message));
    setEnriching(false);
    setEnrichStatus(`Enriched ${newVerseIds.length} verses.`);
    setTimeout(() => {
      navigate('/search-verses-system');
    }, 1000);
  };

  return (
    <div className="max-w-2xl mx-auto p-6">
      <h2 className="text-xl font-bold mb-4">Enrich Newly Added Verses</h2>
      <button
        className="mb-4 px-4 py-2 bg-blue-600 text-white rounded disabled:opacity-60"
        onClick={handleEnrichAll}
        disabled={enriching || !verses.length}
      >
        {enriching ? 'Enriching...' : 'Enrich All'}
      </button>
      {enrichStatus && <div className="mb-4 text-green-700">{enrichStatus}</div>}
      <ul>
        {verses.map(v => (
          <li key={v.id} className="mb-2 flex justify-between items-center border-b pb-2">
            <span>
              <b>{v.reference}</b>: {v.text?.slice(0, 60)}...
            </span>
            <button
              className="ml-4 px-3 py-1 bg-gray-200 rounded hover:bg-gray-300"
              onClick={() => navigate(`/edit-verse/${v.id}`)}
            >
              Enrich Individually
            </button>
          </li>
        ))}
      </ul>
      {!verses.length && <div className="text-gray-500">No new verses to enrich.</div>}
    </div>
  );
} 